export const PROCEED_TO_AUTH = "PROCEED_TO_AUTH";
export const PROCEED_TO_AUTH_ERROR_DATA = "PROCEED_TO_AUTH_ERROR_DATA";
export const PROCEED_TO_AUTH_HIDE_ERROR_DATA = "PROCEED_TO_AUTH_HIDE_ERROR_DATA";
export const PROCEED_TO_AUTH_START_LOADER = "PROCEED_TO_AUTH_START_LOADER";
export const PROCEED_TO_AUTH_STOP_LOADER = "PROCEED_TO_AUTH_STOP_LOADER";
